import { useCookies } from '@packages/utilities';

export const getHasNewInfiniteScrolling = (cookies: Record<string, string>) => {
  const hasFeatureCookie = 'feature/newInfiniteScrolling' in cookies;

  const isPartOfTestGroup = false;

  return hasFeatureCookie || isPartOfTestGroup;
};

export const useHasNewInfiniteScrolling = () => {
  const { getCookies } = useCookies();

  return getHasNewInfiniteScrolling(getCookies());
};
